import { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";

import Api from "lib/api/httpRequestHelper";

import DialogCreateEdit from "./components/dialog-create-edit";
import TableNotasAtualizacao from "./components/table-notas-atualizacao";
import HeaderClientes from "components/_refactor/headers/clients";
import LoadingData from "components/Loading/LoadingData";
import FilterCard from "components/_refactor/filter-card";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";

const STATUS_OPTIONS = [
  { value: "RASCUNHO", name: "Rascunho", id: 1 },
  { value: "AGENDADO", name: "Agendado", id: 2 },
  { value: "PARCIALMENTE_PUBLICADO", name: "Parcialmente publicado", id: 3 },
  { value: "PUBLICADO", name: "Publicado", id: 4 },
];

export default function NotasAtualizacaoAdmin() {
  const snackbar = useSnackbar();

  const [status, setStatus] = useState("");
  const [notasList, setNotasList] = useState([]);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedNota, setSelectedNota] = useState(null);
  const [searching, setSearching] = useState(true);

  const toggleFormDialog = (formType) => {
    if (formType) {
      setOpenFormDialog(formType);
    }
  };

  const handleSearch = async () => {
    setSearching(true);

    try {
      const res = await Api.get(
        "list",
        "releaseNotesDigitalApi",
        status ? `?status=${status.value}` : "",
        true
      );
      setNotasList(res?.Result || []);
    } catch (error) {
      snackbar.showMessage(error, { severity: "error" });
    } finally {
      setSearching(false);
    }
  };

  const handleStatusChange = (value) => {
    setStatus(value !== "all" ? value : "");
  };

  const handleClearFilters = () => {
    setStatus("");
  };

  const handleDialogClose = () => {
    setSelectedNota(null);
    setOpenFormDialog(null);
    handleSearch();
  };

  useEffect(() => {
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderClientes section="Notas de Atualização" subsection="Conteúdo" />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearch}
          disabled={searching}
          searching={searching}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xs={12} md={4}>
            <AutoCompleteField
              label="Status"
              onChange={handleStatusChange}
              value={status}
              options={STATUS_OPTIONS}
              disabled={searching}
              optionLabelKey="name"
              optionIdKey="id"
            />
          </Grid>
        </FilterCard>

        <LoadingData searching={searching} label="Buscando dados..." />

        {!searching && (
          <TableNotasAtualizacao
            dataTable={notasList}
            toggleFormDialog={toggleFormDialog}
            setSelectedNota={setSelectedNota}
            searching={searching}
          />
        )}
      </Container>

      {Boolean(openFormDialog) && (
        <DialogCreateEdit
          open
          formType={openFormDialog}
          onClose={handleDialogClose}
          selectedNota={selectedNota}
          refresh={handleSearch}
        />
      )}
    </>
  );
}
